var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgCloudIntersect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 191,
    viewBox: "0 0 120 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 186.35V4.70758C4.11929 2.18551 8.57539 0.479827 13.5522 0.0826914C26.0968 -0.918337 36.3942 7.34003 46.686 15.594C50.939 19.0048 55.191 22.4149 59.6003 25.1705C63.2004 27.4204 66.9052 29.5206 70.5992 31.6146C81.8265 37.9791 92.9542 44.2872 100.741 54.5723C111.766 69.1338 120.75 86.6386 119.95 104.881C119.271 120.375 109.967 133.522 100.882 146.361C99.381 148.482 97.8862 150.594 96.4372 152.707C95.0801 154.686 93.7375 156.712 92.3876 158.748C84.2079 171.088 75.7617 183.83 62.2022 189.096C52.7251 192.777 42.7875 190.403 32.6946 187.992C26.3498 186.476 19.9437 184.946 13.5522 184.896C9.02225 184.861 4.50032 185.507 0 186.35Z",
    fill: "#5663DF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgCloudIntersect);
export default __webpack_public_path__ + "static/media/bgCloudIntersect.7757ff2ad8e44a2a7a8198adc73532bd.svg";
export { ForwardRef as ReactComponent };